import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from './usePostHog';
import { marketingPage } from './eventPolicy';
import { captureNavigation } from './navigationTracking';

/** Only public link categories are observed: never DOM labels, inputs or form contents. */
export function MarketingInteractions() {
  const analytics = usePostHog();
  const { pathname } = useLocation();
  useEffect(() => {
    const page = marketingPage(pathname);
    if (page) analytics?.capture('marketing_page_viewed', page);
  }, [analytics, pathname]);
  useEffect(() => {
    if (!analytics) return;
    const click = (event: MouseEvent) => {
      if (event.target instanceof Element) captureNavigation(event.target, window.location.href, analytics.capture);
    };
    document.addEventListener('click', click, true);
    return () => document.removeEventListener('click', click, true);
  }, [analytics]);
  return null;
}
